/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxWeeks: NonNullable<unknown> }} Membership_Freeze_AvailableInputs */

const fr_membership_freeze_available = /** @type {(inputs: Membership_Freeze_AvailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vous pouvez mettre votre abonnement en pause une fois par année de contrat, jusqu'à ${i?.maxWeeks} semaines. Votre prochain prélèvement et la fin de votre engagement sont décalés d'autant.`)
};

/**

* @param {Membership_Freeze_AvailableInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_available = /** @type {((inputs: Membership_Freeze_AvailableInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_AvailableInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_available(inputs)
});